const formBodyString = (data: any) => {
  const formBody = [];
  for (const key in data) {
    formBody.push(key + "=" + data[key]);
  }
  const formBodyString = formBody.join("&");

  return formBodyString;
};

export default formBodyString;